// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://tzowmzqfbicbyvikhdwy.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InR6b3dtenFmYmljYnl2aWtoZHd5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTEzODA4OTEsImV4cCI6MjA2Njk1Njg5MX0.ISwDLrKZV8Ug6Ej4puA5miPHBvrN70osv0hv-hHfc8U";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

// CRITICAL PLATFORM MEMORY: Always build everything REAL/AUTHENTIC, never demo/fake data
// - Real AIs from hotel should actually move to school to learn
// - Each school step should provide actual learning value
// - Never use demo data - it creates massive cleanup work later
// - Build authentic systems from day one

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});
